import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, NgModule, OnInit } from '@angular/core';
import { Cms } from '@impact/data';

import { MapsLocation, MapView } from '../../maps/maps.component';
import { MapsModule } from '../../maps/maps.module';
import { NavigationService } from '../../navigation/navigation.service';
import { SpotsUiModule } from '../../spots/spots-ui.module';
import { forkJoin } from 'rxjs';
import { CommonModule } from '@angular/common';
import { GlobalDataService } from '../../core/global-data.service';
import { take } from 'rxjs/operators';

@Component({
    selector: 'app-dealerships-overview-page',
    template: `
        <main>
            <section class="page-content">
                <app-maps *ngIf="dealershipLocations?.length" [mapView]="mapView.ALL_DEALERSHIPS" [locations]="dealershipLocations"></app-maps>
            </section>

            <section class="page-grid-content">
                <app-spot-grid [grid]="data?.mainGrid"></app-spot-grid>
            </section>
        </main>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DealershipsOverviewPageComponent implements OnInit {
    public static ref = 'dealershipsOverviewPage';

    @Input() data: Cms.DealershipsOverviewPage;
    mapView = MapView;
    dealershipsNavigationData: Cms.NavigationDto[];

    dealershipLocations: MapsLocation[] = [];

    constructor(
        private navigationsService: NavigationService,
        private globalDataService: GlobalDataService,
        private cdr: ChangeDetectorRef
    ) {}

    ngOnInit(): void {
        this.mapDealerships();
    }

    /**
     * Maps dealerships data to navigation data to create array of MapsLocation objects that can be used in maps component
     * @returns {void}
     */
    mapDealerships(): void {
        forkJoin([
            this.globalDataService.getDealerships(),
            this.navigationsService.dealershipsNavigation$.pipe(take(1))
        ]).subscribe(([dealerships, dealershipsNavigation]) => {
            dealershipsNavigation.forEach((navItem) => {
                if (navItem.dealerShipId) {
                    const matchingDealership = dealerships.children.find(dealership => dealership.id === navItem.dealerShipId);
                    if (matchingDealership) {
                        this.dealershipLocations.push({
                            ...matchingDealership,
                            pageUrl: navItem.url
                        });
                    }
                }
            });

            this.cdr.markForCheck();
        });
    }
}

@NgModule({
    declarations: [DealershipsOverviewPageComponent],
    imports: [
        SpotsUiModule,
        MapsModule,
        CommonModule
    ]
})
class DealershipsOverviewPageModule {}

export const LazyComponent = DealershipsOverviewPageComponent;
